import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useMemo, useLayoutEffect, useRef } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import DropdownButton from "react-bootstrap/DropdownButton";
import Accordion from "react-bootstrap/Accordion";
import Dropdown from "react-bootstrap/Dropdown";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { TagsInput } from "react-tag-input-component";
import ColumnResizer from "react-table-column-resizer";
import { defaultOption } from "constants/ui/options";
import { nanoid } from "nanoid";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Popover from "@mui/material/Popover";
import { ModalAllder } from "layouts/ModalAllder";
import ListGroup from "react-bootstrap/ListGroup";
import LoadPR from "layouts/LoadDucument/PurchaseRequisition";
import { NumericFormat } from "react-number-format";
import CurrencyInput from "react-currency-input-field";
import { PRPrint } from "layouts/PrintPR";
import { useReactToPrint } from "react-to-print";
import { ProductHistory } from "layouts/ProductHistory";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, DragOverlay, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { arrayMove, SortableContext, verticalListSortingStrategy, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMstPaymentType } from "../../redux/handlers/master/getAllMstPaymentType.handler";
import { getAllMstPriceCategory } from "../../redux/handlers/master/getAllMstPriceCategory.handler";
import { getAllMstDiscountType } from "../../redux/handlers/master/getAllMstDiscountType.handler";
import { genNewPurchaseReqDocNumber } from "../../redux/handlers/logic/genNewPurchaseReqDocNumber.handler";
import { initState, testState } from "mocks/prData";
import moment from "moment";
import { getAllSupplierInformation } from "../../redux/handlers/logic/getAllSupplierInformation.handler";
import { getAllWarehouse } from "../../redux/handlers/master/getAllWarehouse.handler";
import { getAllProductPrice } from "../../redux/handlers/logic/getAllProductPrice.handler";
import { debounce } from "lodash";
import { getAllMstVat } from "../../redux/handlers/master/getAllMstVat.handler";
import { NumberFormat, WDA, base64ToBlob, calPriceByMstCategoryPriceTax, getDiscountValue, getEmpFullNameTHByEmpData, getUnitCost, isReadyToPrint, mappingOptionNewItemPrCol, mappingProductPriceData, setProductRowVatByMstCategoryPrice, sortItemSeq } from "utils/HelperFunction";
import { clearCreateNewPurchaseReq, createNewPurchaseReq } from "../../redux/handlers/logic/createNewPurchaseReq.handler";
import dayjs from "dayjs";
import { getAllMasterBrand } from "../../redux/handlers/master/getAllMasterBrand.handler";
import { getAllMasterMainCategory } from "../../redux/handlers/master/getAllMasterMainCategory.handler";
import { getNewPurchaseReqById } from "../../redux/handlers/logic/getNewPurchaseReqById.handler";
import { getFullUrlPath } from "utils/HandleFileFunction";
import { clearUpdateNewPurchaseReq, updateNewPurchaseReq } from "../../redux/handlers/logic/updateNewPurchaseReq.handler";
import { getAllMstNewItemPrCol } from "../../redux/handlers/master/getAllMstNewItemPrCol.handler";
import DocStatus from "layouts/DocStatus";
import { Pagezoom } from "layouts/Pagezoom";
import { LoadDocument } from "layouts/LoadDucuments";
import { ProductSelect } from "layouts/ProductSelect";
import Productrow from "layouts/Productrow";
import { ProductTableSort } from "layouts/ProductTableSort";
import { ProductTableDisplay } from "layouts/ProductTableDisplay";
import { getUserInfo } from "../../redux/handlers/auth/getUserInfo.handler";
import { isDisabledEditPr, mappingPr } from "utils/HelperPrFunction";
import { getHQAddressByDate } from "../../redux/handlers/logic/getHQAddressByDate.handler";
import { getFirstMstCompany } from "../../redux/handlers/master/getFirstMstCompany.handler";
export function PRCreate() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var prID = useParams().prID;
    var _useState = _sliced_to_array(useState([]), 2), productRow = _useState[0], setProductRow = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductPrice = _useState1[0], setSumproductPrice = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumproductNoVat = _useState2[0], setSumproductNoVat = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumproductZeroVat = _useState3[0], setSumproductZeroVat = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), sumproductSevenVat = _useState4[0], setSumproductSevenVat = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumproductBeforeVat = _useState5[0], setSumproductBeforeVat = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), updateDocIds = _useState6[0], setUpdateDocIds = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        columnsort: [
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            }
        ],
        type: "select"
    }), 2), columnsort = _useState7[0], setColumnsort = _useState7[1];
    var schema = yup.object().shape({
        doc_issue_date: yup.string().required(),
        dim_mst_price_category_id: yup.string().required(),
        dim_supplier_information_id: yup.string().required(),
        dim_mst_payment_type_id: yup.string().required(),
        is_one_receiving_point: yup.string().required(),
        delivery_date: yup.string().required().test("delivery-date-check", "Delivery date must be greater than or equal to the issue date", function(value) {
            var doc_issue_date = this.parent.doc_issue_date;
            return value >= doc_issue_date;
        }),
        delivery_time: yup.string().required(),
        dim_warehouse_id: yup.string().when("is_one_receiving_point", {
            is: function(v) {
                return v == 1;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        dim_new_purchase_req_items: yup.array().of(yup.object().shape({
            dim_warehouse_id: yup.string().required("Warehouse ID is required.")
        })),
        not_approve_reason: yup.string().when([], {
            is: function() {
                return modalNotApprove.open;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        dim_mst_new_status_id: yup.string().when([], {
            is: function() {
                return modalNotApprove.open;
            },
            then: function(schema) {
                return schema.required();
            }
        })
    });
    var _useState8 = _sliced_to_array(useState(false), 2), formdisabled = _useState8[0], setFormdisabled = _useState8[1];
    var _useState9 = _sliced_to_array(useState(initState), 2), formdata = _useState9[0], setFormdata = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        company: "บริษัท เอนเทอร์ อีเอสซี จำกัด (สำนักงานใหญ่) - 00000",
        address: "341/3 ซอยสะพานยาวบ้านใหม่ , วัดพระยาไกร, บางคอแหลม, กรุงเทพมหานคร, 10120",
        phoneNumber: "(02) 291 6833",
        shortName: "อร่อยดี"
    }), 2), distributorAddress = _useState10[0], setDistributorAddress = _useState10[1];
    var _useState11 = _sliced_to_array(useState(""), 2), docDate = _useState11[0], setDocDate = _useState11[1];
    var _useState12 = _sliced_to_array(useState(""), 2), sendDate = _useState12[0], setSendDate = _useState12[1];
    var priceType = [
        {
            value: 1,
            label: "แยกภาษี"
        }
    ];
    var paymentType = [
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "เครดิต"
        }
    ];
    var warehouse = [
        {
            value: 1,
            label: "คลัง 1"
        },
        {
            value: 2,
            label: "คลัง 2"
        }
    ];
    var discountType = [
        {
            value: 1,
            label: "%"
        },
        {
            value: 2,
            label: "บาท"
        }
    ];
    var _useState13 = _sliced_to_array(useState({
        id: "",
        dimGroupOfSupplierCode: "",
        full_supplier_name: "-",
        initials: "-",
        company_branch_code: "",
        company_branch_name: "",
        full_supplier_address_name: "-",
        company_phone_number: "-"
    }), 2), pdata = _useState13[0], setPdata = _useState13[1];
    var distributor = [
        {
            distributorID: 1,
            distributorCode: "CP202004230002",
            distributorName: "บริษัท ไทย อกริฟู้ดส์ จำกัด",
            distributorNameShort: "อร่อยดี",
            branchCode: "00000",
            branchName: "สำนักงานใหญ่",
            address: "341/3 ซอยสะพานยาวบ้านใหม่ , วัดพระยาไกร, บางคอแหลม, กรุงเทพมหานคร, 10120",
            phoneNumber: "089-899-8999"
        },
        {
            distributorID: 2,
            distributorCode: "CP202004230003",
            distributorName: "บริษัท ไทยออล จำกัด",
            distributorNameShort: "ซีพี",
            branchCode: "00000",
            branchName: "สำนักงานใหญ่",
            address: "341/3 ซอยสะพานยาวบ้านใหม่ , วัดพระยาไกร, บางคอแหลม, กรุงเทพมหานคร, 10120",
            phoneNumber: "089-899-8999"
        }
    ];
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.full_supplier_name
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#8E8E8F"
                    },
                    children: item.initials
                })
            ]
        }, item.id);
    };
    var _useState14 = _sliced_to_array(useState(1), 2), tab = _useState14[0], setTab = _useState14[1];
    var _useState15 = _sliced_to_array(useState([]), 2), tagselected = _useState15[0], setTagSelected = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), attachments = _useState16[0], setAttachments = _useState16[1];
    var handlePreviewFile = function(e, itemIndex) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            var file = e.target.files[0].name.split(".");
            var blobUrl = URL.createObjectURL(e.target.files[0]);
            reader.addEventListener("load", function() {
                var newId = nanoid();
                setAttachments(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            id: newId,
                            docId: "",
                            docFile: e.target.files[0].name,
                            docFileType: file[1],
                            docFileData: reader.result,
                            docUrl: blobUrl
                        }
                    ]);
                });
                e.target.value = "";
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    var deleteDocument = function(removeId) {
        setAttachments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
    };
    var _useState17 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState17[0], setModalSuccess = _useState17[1];
    var _useState18 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success2"
    }), 2), modalApproveRequestSuccess = _useState18[0], setModalApproveRequestSuccess = _useState18[1];
    var _useState19 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "savesuccess2"
    }), 2), modalSaveSuccess = _useState19[0], setModalSaveSuccess = _useState19[1];
    var _useState20 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalApproveSuccess = _useState20[0], setModalApproveSuccess = _useState20[1];
    var _useState21 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalNotApprove = _useState21[0], setModalNotApprove = _useState21[1];
    var _useState22 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 310,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState22[0], setModalAlert = _useState22[1];
    var loadAllMsts = function() {
        dispatch(getAllMstPaymentType());
        dispatch(getAllMstPriceCategory());
        dispatch(getAllMstDiscountType());
        dispatch(getAllMstVat());
        dispatch(getAllWarehouse());
        dispatch(getAllMstNewItemPrCol());
        dispatch(getFirstMstCompany());
    };
    var loadAllResources = function() {
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (!prID) {
            dispatch(genNewPurchaseReqDocNumber({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
        dispatch(getAllSupplierInformation({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var _useState23 = _sliced_to_array(useState([]), 2), optionsMstPaymentType = _useState23[0], setOptionsMstPaymentType = _useState23[1];
    var _useState24 = _sliced_to_array(useState([]), 2), optionsMstPriceCategory = _useState24[0], setOptionsMstPriceCategory = _useState24[1];
    var _useState25 = _sliced_to_array(useState([]), 2), optionsMstDiscountType = _useState25[0], setOptionsMstDiscountType = _useState25[1];
    var _useState26 = _sliced_to_array(useState([]), 2), optionsMstVat = _useState26[0], setOptionsMstVat = _useState26[1];
    var _useState27 = _sliced_to_array(useState([]), 2), optionsWarehouse = _useState27[0], setOptionsWarehouse = _useState27[1];
    var _useState28 = _sliced_to_array(useState([]), 2), optionNewItemPrCol = _useState28[0], setOptionNewItemPrCol = _useState28[1];
    var _useState29 = _sliced_to_array(useState(), 2), userInfo = _useState29[0], setUserInfo = _useState29[1];
    var _useState30 = _sliced_to_array(useState(), 2), companyInfo = _useState30[0], setCompanyInfo = _useState30[1];
    var getAllMstPaymentTypeReducer = useAppSelector(function(state) {
        return state.getAllMstPaymentTypeReducer;
    });
    var getAllMstPriceCategoryReducer = useAppSelector(function(state) {
        return state.getAllMstPriceCategoryReducer;
    });
    var getAllMstDiscountTypeReducer = useAppSelector(function(state) {
        return state.getAllMstDiscountTypeReducer;
    });
    var getAllMstVatReducer = useAppSelector(function(state) {
        return state.getAllMstVatReducer;
    });
    var getAllWarehouseReducer = useAppSelector(function(state) {
        return state.getAllWarehouseReducer;
    });
    var getAllMstNewItemPrColReducer = useAppSelector(function(state) {
        return state.getAllMstNewItemPrColReducer;
    });
    var getUserInfoReducer = useAppSelector(function(state) {
        return state.getUserInfoReducer;
    });
    var getFirstMstCompanyReducer = useAppSelector(function(state) {
        return state.getFirstMstCompanyReducer;
    });
    useEffect(function() {
        loadAllMsts();
        loadAllResources();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstPaymentTypeReducer.isFetching || getAllMstPriceCategoryReducer.isFetching || getAllMstDiscountTypeReducer.isFetching || getAllMstVatReducer.isFetching || getUserInfoReducer.isFetching || getFirstMstCompanyReducer.isFetching);
        if (getFirstMstCompanyReducer.data) {
            setCompanyInfo(getFirstMstCompanyReducer.data.data);
        }
        if (getUserInfoReducer.data) {
            setUserInfo(getUserInfoReducer.data.data);
        }
        if (getAllMstPaymentTypeReducer.data) {
            setOptionsMstPaymentType(getAllMstPaymentTypeReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstPriceCategoryReducer.data) {
            setOptionsMstPriceCategory(getAllMstPriceCategoryReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstDiscountTypeReducer.data) {
            setOptionsMstDiscountType(getAllMstDiscountTypeReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstVatReducer.data) {
            setOptionsMstVat(getAllMstVatReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id,
                    vat: item.value
                };
            }));
        }
        if (getAllWarehouseReducer.data) {
            setOptionsWarehouse(getAllWarehouseReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstNewItemPrColReducer.data) {
            var optionsMap = mappingOptionNewItemPrCol(getAllMstNewItemPrColReducer.data.data);
            setOptionNewItemPrCol(optionsMap);
        }
    }, [
        getAllMstPaymentTypeReducer,
        getAllMstPriceCategoryReducer,
        getAllMstDiscountTypeReducer,
        getAllMstVatReducer,
        getAllWarehouseReducer,
        getAllMstNewItemPrColReducer,
        getUserInfoReducer
    ]);
    var genNewPurchaseReqDocNumberReducer = useAppSelector(function(state) {
        return state.genNewPurchaseReqDocNumberReducer;
    });
    var _useState31 = _sliced_to_array(useState([]), 2), supplierInfos = _useState31[0], setSupplierInfos = _useState31[1];
    var getAllSupplierInformationReducer = useAppSelector(function(state) {
        return state.getAllSupplierInformationReducer;
    });
    useEffect(function() {
        setIsLoading(genNewPurchaseReqDocNumberReducer.isFetching || getAllSupplierInformationReducer.isFetching);
        if (genNewPurchaseReqDocNumberReducer.data) {
            setFormdata(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    doc_number: genNewPurchaseReqDocNumberReducer.data.data
                });
            });
        }
        if (getAllSupplierInformationReducer.data) {
            setSupplierInfos(getAllSupplierInformationReducer.data.data);
        }
    }, [
        genNewPurchaseReqDocNumberReducer,
        getAllSupplierInformationReducer
    ]);
    var createNewPurchaseReqReducer = useAppSelector(function(state) {
        return state.createNewPurchaseReqReducer;
    });
    useEffect(function() {
        setIsLoading(createNewPurchaseReqReducer.isFetching);
        if (createNewPurchaseReqReducer.data && !createNewPurchaseReqReducer.isError) {
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setFormdisabled(true);
            dispatch(clearCreateNewPurchaseReq());
            var createdData = createNewPurchaseReqReducer.data.data;
            var id = createdData && createdData.id ? createdData.id : null;
            if (id) {
                navigate("/purchase/requisition/edit/".concat(id));
            } else {
                navigate("/purchase/requisition");
            }
        }
    }, [
        createNewPurchaseReqReducer
    ]);
    var getNewPurchaseReqByIdReducer = useAppSelector(function(state) {
        return state.getNewPurchaseReqByIdReducer;
    });
    var getData = function() {
        dispatch(getNewPurchaseReqById(prID, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var _useState32 = _sliced_to_array(useState("สร้างใบขอซื้อ"), 2), headerName = _useState32[0], setheaderName = _useState32[1];
    useEffect(function() {
        if (prID) {
            getData();
            setheaderName("แก้ไขใบขอซื้อ");
        } else {
            setFormdata(initState);
        }
    }, [
        prID
    ]);
    useEffect(function() {
        setIsLoading(getNewPurchaseReqByIdReducer.isFetching);
        if (getNewPurchaseReqByIdReducer.data && !getNewPurchaseReqByIdReducer.isError && prID) {
            var prData = getNewPurchaseReqByIdReducer.data.data;
            if (!prData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = mappingPr({
                prData: prData,
                setPdata: setPdata,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort,
                setAttachments: setAttachments,
                setTagSelected: setTagSelected
            });
            var endDate = dataWithReplacements.doc_issue_date;
            getHQAddress({
                end_date: endDate
            });
            setFormdata(dataWithReplacements);
        }
    }, [
        getNewPurchaseReqByIdReducer
    ]);
    var getHQAddressByDateReducer = useAppSelector(function(state) {
        return state.getHQAddressByDateReducer;
    });
    var getHQAddress = function(payload) {
        dispatch(getHQAddressByDate(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(getHQAddressByDateReducer.isFetching);
        if (getHQAddressByDateReducer.data && !getHQAddressByDateReducer.isError && prID) {
            var hqAddress = getHQAddressByDateReducer.data.data;
            if (!hqAddress) {
                return navigate("/404", {
                    replace: true
                });
            }
            setFormdata(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    hqAddress: hqAddress
                });
            });
        }
    }, [
        getHQAddressByDateReducer
    ]);
    var updateNewPurchaseReqReducer = useAppSelector(function(state) {
        return state.updateNewPurchaseReqReducer;
    });
    useEffect(function() {
        setIsLoading(updateNewPurchaseReqReducer.isFetching);
        if (updateNewPurchaseReqReducer.data && !updateNewPurchaseReqReducer.isError) {
            setModalNotApprove(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            getData();
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            dispatch(clearUpdateNewPurchaseReq());
        }
    }, [
        updateNewPurchaseReqReducer
    ]);
    useEffect(function() {
        if (prID) {
            var deleteCandidateDocIds = formdata.dimDocFilePr ? formdata.dimDocFilePr.map(function(item) {
                return item.id;
            }) : [];
            var deleteDocIds = deleteCandidateDocIds.filter(function(docId) {
                return !attachments.some(function(doc) {
                    return doc.docId === docId;
                });
            });
            var allDocIds = _to_consumable_array(deleteDocIds);
            console.log("All Doc IDs to update or delete:", allDocIds);
            setUpdateDocIds(allDocIds);
        }
    }, [
        prID,
        attachments
    ]);
    var componentRef = useRef();
    var handlePrint = useReactToPrint({
        content: function() {
            return componentRef.current;
        }
    });
    var _useState33 = _sliced_to_array(useState(true), 2), Collapse = _useState33[0], setCollapse = _useState33[1];
    return /*#__PURE__*/ _jsxs("div", {
        className: "document-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดซื้อ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบขอซื้อ PR"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        headerName,
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: headerName
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var _loop = function(key) {
                        if (Object.hasOwnProperty.call(values, key)) {
                            var value = values[key];
                            if (key === "dim_employee_attached_doc" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "update_doc_ids" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "update_doc_types" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "tag_prs" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "dim_new_purchase_req_items" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "doc_files" && Array.isArray(value)) {
                                value.forEach(function(base64String, index) {
                                    if (base64String) {
                                        var blob = base64ToBlob(base64String);
                                        formdataPayload.append("".concat(key), blob, "document_".concat(index, ".pdf"));
                                    }
                                });
                            } else if (Array.isArray(value)) {
                                value.forEach(function(item) {
                                    return formdataPayload.append(key, item);
                                });
                            } else if (value !== undefined) {
                                formdataPayload.append(key, value);
                            }
                        }
                    };
                    // console.log(values);
                    var formdataPayload = new FormData();
                    for(var key in values)_loop(key);
                    // console.log(formdataPayload);
                    if (!prID) {
                        dispatch(createNewPurchaseReq(formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        dispatch(updateNewPurchaseReq(prID, formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                // alert('dfgdfg')
                // setFormdisabled(true)
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            var product = productRow.filter(function(prev) {
                                return prev.productCode !== "";
                            });
                            if (product && product.length > 0) {
                                var newItems = product.map(function(v) {
                                    return {
                                        dim_product_price_id: v.productID,
                                        dim_warehouse_id: v.warehouseID,
                                        quantity: v.productQty,
                                        unit_price: v.productPrice,
                                        unit_id: v.productUnitID,
                                        ratio_unit: v.productRatioUnit,
                                        container: v.productContainer,
                                        dim_mst_discount_type_id: v.discountType,
                                        discount_value: v.discountType === 1 ? v.discountPercent : v.discount,
                                        dim_mst_vat_id: v.dim_mst_vat_id,
                                        remark: v.note
                                    };
                                });
                                schema.validate(_object_spread_props(_object_spread({}, values), {
                                    dim_new_purchase_req_items: newItems
                                }), {
                                    abortEarly: false
                                }).then(function() {
                                    setFieldValue("doc_files", attachments.map(function(v) {
                                        return v.docFileData;
                                    }));
                                    setFieldValue("dim_new_purchase_req_items", newItems);
                                    setFieldValue("tag_prs", tagselected);
                                    if (prID) {
                                        setFieldValue("update_doc_ids", updateDocIds);
                                    }
                                    handleSubmit();
                                }).catch(function(err) {
                                    console.log(err);
                                });
                            } else {
                                setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mx-auto mb-4 pb-3 pagezoom",
                                        style: {
                                            maxWidth: "700px"
                                        },
                                        children: /*#__PURE__*/ _jsx(Steps, {
                                            prstatus: prID && values.dimMstNewStatus ? values.dimMstNewStatus.id : 0
                                        })
                                    }),
                                    prID && values.canceledNewPrEmp && /*#__PURE__*/ _jsxs("div", {
                                        className: "cancel-warn pagezoom mb-4",
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: "/images/icon-warn-red.png"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16",
                                                children: "".concat(moment(values.canceled_at, "YYYY-MM-DD HH:mm:ss").add(7, "hours").format("DD/MM/YYYY HH:mm:ss"), " โดย ").concat(getEmpFullNameTHByEmpData(values.canceledNewPrEmp), " “").concat(values.not_approve_reason, "”")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card pagezoom card-st-3 mb-4",
                                        style: {
                                            minWidth: "1000px"
                                        },
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                id: "",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "pt-3 px-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "row row gx-xl-4",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-12",
                                                                    children: prID && values.dimMstNewStatus && /*#__PURE__*/ _jsx("div", {
                                                                        className: "d-flex justify-content-end align-items-center h-100",
                                                                        children: /*#__PURE__*/ _jsx(DocStatus, {
                                                                            statusName: values.dimMstNewStatus.name,
                                                                            statusID: values.dimMstNewStatus.id
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "เลขที่ใบขอซื้อ",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "doc_number",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: values.doc_number,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.doc_number,
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-3 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "วันที่ออกเอกสาร",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                                                    inputFormat: "DD/MM/YYYY",
                                                                                    selected: docDate,
                                                                                    onChange: function(date) {
                                                                                        setDocDate(date);
                                                                                        setFieldValue("doc_issue_date", moment(date).format("YYYY-MM-DD"));
                                                                                    },
                                                                                    placeholder: "DD/MM/YYYY",
                                                                                    className: "w-100 datepicker2 ".concat(values.doc_issue_date ? "" : !!errors.doc_issue_date ? "is-invalid" : ""),
                                                                                    value: values.doc_issue_date ? moment(values.doc_issue_date).format("DD/MM/YYYY") : ""
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ประเภทราคา"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                    as: "select",
                                                                                    name: "dim_mst_price_category_id",
                                                                                    onChange: function(e) {
                                                                                        setFieldValue("dim_mst_price_category_id", e.value);
                                                                                    },
                                                                                    className: "w-100 select-st-1 ".concat(formdisabled ? "pointer-events-none" : "", " ").concat(values.dim_mst_price_category_id ? "" : !!errors.dim_mst_price_category_id ? "is-invalid" : ""),
                                                                                    options: optionsMstPriceCategory,
                                                                                    placeholder: "เลือกประเภทราคา",
                                                                                    value: optionsMstPriceCategory.filter(function(item) {
                                                                                        return item.value === values.dim_mst_price_category_id;
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "อ้างอิงระบบ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: "-",
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    style: {
                                                                                        zIndex: 11
                                                                                    },
                                                                                    children: [
                                                                                        "ผู้จัดจำหน่าย",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                                                                                    items: supplierInfos,
                                                                                    placeholder: "ค้นหา",
                                                                                    onSelect: function(item) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            dim_supplier_information_id: item.id,
                                                                                            dim_mst_payment_type_id: item.dim_mst_payment_type_id ? item.dim_mst_payment_type_id : values.dim_mst_payment_type_id,
                                                                                            dim_mst_price_category_id: item.dim_mst_price_category_id ? item.dim_mst_price_category_id : values.dim_mst_price_category_id
                                                                                        }));
                                                                                        setPdata(function(prev) {
                                                                                            return {
                                                                                                id: item.id,
                                                                                                dimGroupOfSupplierCode: item.dimGroupOfSupplier ? item.dimGroupOfSupplier.code : "-",
                                                                                                full_supplier_name: item.full_supplier_name,
                                                                                                initials: item.initials,
                                                                                                company_branch_code: item.company_branch_code,
                                                                                                company_branch_name: item.company_branch_name,
                                                                                                full_supplier_address_name: item.full_supplier_address_name,
                                                                                                company_phone_number: item.company_phone_number
                                                                                            };
                                                                                        });
                                                                                    },
                                                                                    onClear: function() {
                                                                                        setFieldValue("dim_supplier_information_id", "");
                                                                                        setPdata(function(prev) {
                                                                                            return {
                                                                                                id: "",
                                                                                                dimGroupOfSupplierCode: "",
                                                                                                full_supplier_name: "-",
                                                                                                initials: "-",
                                                                                                company_branch_code: "",
                                                                                                company_branch_name: "",
                                                                                                full_supplier_address_name: "-",
                                                                                                company_phone_number: "-"
                                                                                            };
                                                                                        });
                                                                                    },
                                                                                    autoFocus: true,
                                                                                    formatResult: formatResult,
                                                                                    fuseOptions: {
                                                                                        keys: [
                                                                                            "dimGroupOfSupplierCode",
                                                                                            "full_supplier_name",
                                                                                            "initials"
                                                                                        ]
                                                                                    },
                                                                                    resultStringKeyName: "full_supplier_name",
                                                                                    styling: {
                                                                                        height: "54px",
                                                                                        borderRadius: "10px",
                                                                                        boxShadow: "none",
                                                                                        zIndex: 10,
                                                                                        border: !values.dim_supplier_information_id ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                                                                                    },
                                                                                    showIcon: false,
                                                                                    className: "scrollSearchAutocomplete"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "เงื่อนไขการชำระเงิน"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                    as: "select",
                                                                                    name: "dim_mst_payment_type_id",
                                                                                    onChange: function(e) {
                                                                                        setFieldValue("dim_mst_payment_type_id", e.value);
                                                                                    },
                                                                                    className: "w-100 select-st-1 ".concat(formdisabled ? "pointer-events-none" : "", " ").concat(values.dim_mst_payment_type_id ? "" : !!errors.dim_mst_payment_type_id ? "is-invalid" : ""),
                                                                                    options: optionsMstPaymentType,
                                                                                    placeholder: "เลือกเงื่อนไขการชำระเงิน",
                                                                                    value: optionsMstPaymentType.filter(function(item) {
                                                                                        return item.value === values.dim_mst_payment_type_id;
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "อ้างอิง"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "refer",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: values.refer,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.refer
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "ผู้จัดทำเอกสาร",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "ผู้จัดทำเอกสาร",
                                                                                    value: getEmpFullNameTHByEmpData(prID ? values.createdNewPrEmp : userInfo === null || userInfo === void 0 ? void 0 : userInfo.dimNewAlldernowEmp),
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "pb-4 pt-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold fs-18 mb-2",
                                                                                    children: "บริษัท"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: pdata.full_supplier_name
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "pb-4 pt-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold fs-18 mb-2",
                                                                                    children: "ที่อยู่"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        children: pdata.full_supplier_address_name
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "pb-4 pt-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold fs-18 mb-2",
                                                                                    children: "เบอร์โทร"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        children: pdata.company_phone_number
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "pb-4 pt-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold fs-18 mb-2",
                                                                                    children: "ชื่อย่อ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        children: pdata.initials
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "col-xl-6 col-7 row align-items-center",
                                                                        style: !!errors.is_one_receiving_point ? {
                                                                            border: "1px solid #dc3545",
                                                                            marginRight: "15px",
                                                                            borderRadius: "10px"
                                                                        } : {},
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-auto",
                                                                                children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    label: "รับสินค้าจุดเดียว",
                                                                                    name: "is_one_receiving_point",
                                                                                    type: "radio",
                                                                                    id: "mn-radio-21",
                                                                                    className: "form-check-st-2 tc-7",
                                                                                    checked: values.is_one_receiving_point,
                                                                                    onChange: function(e) {
                                                                                        setFieldValue("is_one_receiving_point", true);
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "คลังสินค้า"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            name: "dim_warehouse_id",
                                                                                            onChange: function(e) {
                                                                                                setFieldValue("dim_warehouse_id", e.value);
                                                                                                setFieldValue("warehouseName", e.label);
                                                                                            },
                                                                                            className: "w-100 select-st-1 ".concat(formdisabled ? "pointer-events-none" : "", " ").concat(values.dim_warehouse_id ? "" : !!errors.dim_warehouse_id ? "is-invalid" : ""),
                                                                                            options: optionsWarehouse,
                                                                                            placeholder: "เลือกคลังสินค้า",
                                                                                            value: optionsWarehouse.filter(function(item) {
                                                                                                return item.value === values.dim_warehouse_id;
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-auto",
                                                                                children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    label: "รับสินค้ามากกว่า 1 จุด",
                                                                                    name: "is_one_receiving_point",
                                                                                    type: "radio",
                                                                                    id: "mn-radio-22",
                                                                                    className: "form-check-st-2 tc-7",
                                                                                    checked: !values.is_one_receiving_point,
                                                                                    onChange: function(e) {
                                                                                        setFieldValue("is_one_receiving_point", false);
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "col-xl-6 col-5 row  align-items-center",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-3 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "วันที่จัดส่ง",
                                                                                                " "
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                                            inputFormat: "DD/MM/YYYY",
                                                                                            selected: sendDate,
                                                                                            onChange: function(date) {
                                                                                                setSendDate(date);
                                                                                                setFieldValue("delivery_date", moment(date).format("YYYY-MM-DD"));
                                                                                            },
                                                                                            placeholder: "DD/MM/YYYY",
                                                                                            className: "w-100 datepicker2 ".concat(!!errors.delivery_date ? "is-invalid" : ""),
                                                                                            value: values.delivery_date ? moment(values.delivery_date).format("DD/MM/YYYY") : ""
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col",
                                                                                id: "tn",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-3 form-st-3 timePicker pb-1 position-relative",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "เวลาจัดส่ง",
                                                                                                " "
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                                            dateAdapter: AdapterDayjs,
                                                                                            children: /*#__PURE__*/ _jsx(TimePicker, {
                                                                                                views: [
                                                                                                    "hours",
                                                                                                    "minutes"
                                                                                                ],
                                                                                                format: "HH:mm",
                                                                                                ampm: false,
                                                                                                label: "",
                                                                                                sx: {
                                                                                                    border: 0
                                                                                                },
                                                                                                value: values.delivery_date && values.delivery_time ? dayjs("".concat(moment(new Date()).format("YYYY-MM-DD"), "T").concat(values.delivery_time)) : null,
                                                                                                onChange: function(time) {
                                                                                                    var formattedTime = moment(time.$d).format("HH:mm");
                                                                                                    console.log(formattedTime);
                                                                                                    setFieldValue("delivery_time", formattedTime);
                                                                                                },
                                                                                                slotProps: {
                                                                                                    popper: {
                                                                                                        container: document.getElementById("tn"),
                                                                                                        placement: "bottom-end"
                                                                                                    }
                                                                                                },
                                                                                                className: "".concat(values.delivery_time ? "" : !!errors.delivery_time ? "is-invalid" : "")
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-3 pagezoom",
                                        children: [
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-st-3 me-3",
                                                style: tab != 1 ? {
                                                    background: "transparent",
                                                    border: 0,
                                                    color: "#9C9C9C"
                                                } : {},
                                                onClick: function() {
                                                    return setTab(1);
                                                },
                                                children: "ข้อมูลสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-st-3",
                                                style: tab != 2 ? {
                                                    background: "transparent",
                                                    border: 0,
                                                    color: "#9C9C9C"
                                                } : {},
                                                onClick: function() {
                                                    return setTab(2);
                                                },
                                                children: "รายละเอียดการสั่งซื้อ"
                                            })
                                        ]
                                    }),
                                    tab == 1 ? /*#__PURE__*/ _jsx(ProductData, {
                                        values: values,
                                        setFieldValue: setFieldValue,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        sumproductPrice: sumproductPrice,
                                        setSumproductPrice: setSumproductPrice,
                                        sumproductNoVat: sumproductNoVat,
                                        setSumproductNoVat: setSumproductNoVat,
                                        sumproductZeroVat: sumproductZeroVat,
                                        setSumproductZeroVat: setSumproductZeroVat,
                                        sumproductSevenVat: sumproductSevenVat,
                                        setSumproductSevenVat: setSumproductSevenVat,
                                        sumproductBeforeVat: sumproductBeforeVat,
                                        setSumproductBeforeVat: setSumproductBeforeVat,
                                        optionsWarehouse: optionsWarehouse,
                                        optionsMstDiscountType: optionsMstDiscountType,
                                        optionsMstVat: optionsMstVat,
                                        optionNewItemPrCol: optionNewItemPrCol,
                                        columnsort: columnsort,
                                        setColumnsort: setColumnsort,
                                        setFormdata: setFormdata,
                                        setPdata: setPdata,
                                        formdisabled: formdisabled
                                    }) : /*#__PURE__*/ _jsx(OrderDetail, {
                                        dimNewPurchaseOrder: values.dimNewPurchaseOrder
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("fieldset", {
                                disabled: formdisabled,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold",
                                                            children: "สรุปข้อมูล"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumproductPrice, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "d-flex align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "ส่วนลด "
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "d-flex align-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                    type: "number",
                                                                                                    name: "discount_value",
                                                                                                    className: "form-control",
                                                                                                    placeholder: "",
                                                                                                    value: values.discount_value,
                                                                                                    onChange: handleChange,
                                                                                                    isInvalid: !!errors.discount_value,
                                                                                                    style: {
                                                                                                        borderRight: 0,
                                                                                                        borderTopRightRadius: 0,
                                                                                                        borderBottomRightRadius: 0,
                                                                                                        width: "80px"
                                                                                                    }
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                                    as: "select",
                                                                                                    name: "dim_mst_discount_type_id",
                                                                                                    onChange: function(e) {
                                                                                                        setFieldValue("dim_mst_discount_type_id", e.value);
                                                                                                    },
                                                                                                    className: "w-100  select-st-2 ".concat(formdisabled ? "pointer-events-none" : ""),
                                                                                                    options: optionsMstDiscountType,
                                                                                                    placeholder: "",
                                                                                                    value: optionsMstDiscountType.filter(function(item) {
                                                                                                        return item.value === values.dim_mst_discount_type_id;
                                                                                                    }),
                                                                                                    style: {
                                                                                                        borderLeft: 0,
                                                                                                        borderTopLeftRadius: 0,
                                                                                                        borderBottomLeftRadius: 0,
                                                                                                        width: "80px"
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    value: NumberFormat(getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value))
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้ายกเว้นภาษี"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductNoVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 0 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductZeroVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 7 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "ภาษีมูลค่าเพิ่ม"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true) * 0.07, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-auto",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-3 mt-2",
                                                                children: " มูลค่าสุทธิรวม"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "text-white fs-24",
                                                                style: {
                                                                    background: "#FF6B00",
                                                                    padding: "12px 20px",
                                                                    borderRadius: "8px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            fontWeight: 700,
                                                                            fontSize: "28px"
                                                                        },
                                                                        children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 ms-2",
                                                                        children: "บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "หมายเหตุ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            as: "textarea",
                                                                            rows: 3,
                                                                            name: "remark",
                                                                            value: values.remark,
                                                                            onChange: handleChange
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6 tag-st-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "แท็ก"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TagsInput, {
                                                                            value: tagselected,
                                                                            onChange: setTagSelected,
                                                                            name: "tag",
                                                                            placeHolder: ""
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    })
                                                ]
                                            }) : "",
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex justify-content-end align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(false);
                                                        },
                                                        disabled: !Collapse,
                                                        children: "ย่อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(true);
                                                        },
                                                        disabled: Collapse,
                                                        children: "ขยาย"
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-bold fs-18 mb-3",
                                                        children: "ไฟล์แนบ"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "pb-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn  btn-upload-file mb-4",
                                                                onClick: function(e) {
                                                                    return document.getElementById("fileUpload").click();
                                                                },
                                                                children: "อัพโหลดไฟล์แนบ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "file",
                                                                name: "",
                                                                className: "fileUpload hide-input",
                                                                id: "fileUpload",
                                                                accept: ".pdf",
                                                                onChange: function(e) {
                                                                    handlePreviewFile(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "d-flex align-items-center flex-wrap",
                                                                children: attachments.map(function(item, index) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex align-items-center me-3 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "me-3",
                                                                                children: index + 1
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "".concat(item.docUrl),
                                                                                target: "_blank",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "docfile",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "icon ".concat(item.docFileType)
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "name fs-18",
                                                                                            children: item.docFile
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("button", {
                                                                                type: "button",
                                                                                className: "btn  btn-delete-file-cross ms-3",
                                                                                onClick: function(e) {
                                                                                    return deleteDocument(item.id);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow",
                                style: {
                                    minWidth: "1000px"
                                },
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3 d-flex ",
                                    children: [
                                        isReadyToPrint(formdisabled, values.dimMstNewStatus ? values.dimMstNewStatus.id : 0) && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    style: {
                                                        display: "none"
                                                    },
                                                    children: /*#__PURE__*/ _jsx(PRPrint, {
                                                        innerRef: componentRef,
                                                        values: values,
                                                        companyInfo: companyInfo
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs(Button, {
                                                    type: "button",
                                                    className: "btn-st-8 fs-14 border-0 px-3 me-3",
                                                    onClick: handlePrint,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("i", {
                                                            className: "iprinter"
                                                        }),
                                                        "พิมพ์เอกสาร"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Dropdown, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                                            className: "btn btn-st-8 fs-14  px-4",
                                                            id: "dropdown-basic",
                                                            style: {
                                                                backgroundColor: "#565DFF",
                                                                borderColor: "#565DFF",
                                                                height: "40px"
                                                            },
                                                            children: "ตัวเลือก"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                                            className: "p-0 border-0",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-6  w-100 ",
                                                                    children: "คัดลอกเอกสาร"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-6  w-100",
                                                                    children: "ยกเลิกเอกสาร"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                navigate("/purchase/requisition");
                                            },
                                            className: "btn-st-6 me-3 btn ms-auto",
                                            children: "ยกเลิก"
                                        }),
                                        !formdisabled && (!values.dimMstNewStatus || values.dimMstNewStatus && values.dimMstNewStatus.id < 3 || values.dimMstNewStatus && values.dimMstNewStatus.id === 7) && /*#__PURE__*/ _jsx(Button, {
                                            type: "submit",
                                            onClick: function(e) {
                                                // e.preventDefault();
                                                setFieldValue("dim_mst_new_status_id", 1);
                                            },
                                            className: "btn-st-3 me-3",
                                            children: "บันทึกร่าง"
                                        }),
                                        formdisabled && /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function() {
                                                setFormdisabled(false);
                                            },
                                            className: "btn-st-3 me-3 ".concat(isDisabledEditPr({
                                                dimMstNewStatus: values.dimMstNewStatus
                                            }) ? "lock-btn" : ""),
                                            disabled: isDisabledEditPr({
                                                dimMstNewStatus: values.dimMstNewStatus
                                            }),
                                            children: "แก้ไข"
                                        }),
                                        !formdisabled && (!values.dimMstNewStatus || values.dimMstNewStatus && values.dimMstNewStatus.id !== 7) && /*#__PURE__*/ _jsxs(ButtonGroup, {
                                            className: " btn-group-st-1 ",
                                            children: [
                                                !(values.dimMstNewStatus && values.dimMstNewStatus.id > 1) && /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    onClick: function() {
                                                        setFieldValue("dim_mst_new_status_id", 2);
                                                    },
                                                    children: "ส่งอนุมัติ"
                                                }),
                                                !!(values.dimMstNewStatus && values.dimMstNewStatus.id > 1 && values.dimMstNewStatus.id < 3) && /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    onClick: function() {
                                                        setFieldValue("dim_mst_new_status_id", 3);
                                                    },
                                                    children: "อนุมัติ"
                                                }),
                                                !!(values.dimMstNewStatus && values.dimMstNewStatus.id > 2) && /*#__PURE__*/ _jsx(Button, {
                                                    className: "w-100",
                                                    onClick: function() {
                                                        return setModalNotApprove(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: true
                                                            });
                                                        });
                                                    },
                                                    children: "ไม่อนุมัติ"
                                                }),
                                                (!values.dimMstNewStatus || values.dimMstNewStatus && values.dimMstNewStatus.id < 3) && /*#__PURE__*/ _jsxs(DropdownButton, {
                                                    as: ButtonGroup,
                                                    title: "",
                                                    id: "bg-nested-dropdown",
                                                    children: [
                                                        !(values.dimMstNewStatus && values.dimMstNewStatus.id > 1) && /*#__PURE__*/ _jsx(Button, {
                                                            type: "submit",
                                                            onClick: function() {
                                                                setFieldValue("dim_mst_new_status_id", 3);
                                                            },
                                                            children: "อนุมัติ"
                                                        }),
                                                        !!(values.dimMstNewStatus && values.dimMstNewStatus.id > 1) && /*#__PURE__*/ _jsx(Button, {
                                                            className: "w-100",
                                                            onClick: function() {
                                                                return setModalNotApprove(function(prev) {
                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                        open: true
                                                                    });
                                                                });
                                                            },
                                                            children: "ไม่อนุมัติ"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "py-[40px]"
                            }),
                            /*#__PURE__*/ _jsx(ModalAllder, {
                                modal: modalNotApprove,
                                setModal: setModalNotApprove,
                                htitle: "ยืนยันการไม่อนุมัติ",
                                hbtn: false,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "py-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                    className: "mb-1",
                                                    children: [
                                                        "เหตุผลไม่อนุมัติ ",
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-danger",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    as: "textarea",
                                                    rows: 3,
                                                    name: "not_approve_reason",
                                                    onChange: handleChange,
                                                    isInvalid: !values.not_approve_reason,
                                                    value: values.not_approve_reason
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-2  tc-10",
                                                    children: "การดำเนินการ"
                                                }),
                                                [
                                                    "radio"
                                                ].map(function(type) {
                                                    return /*#__PURE__*/ _jsxs("div", {
                                                        className: "mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                inline: true,
                                                                label: "เปลี่ยนเป็นบันทึกร่าง",
                                                                name: "dim_mst_new_status_id",
                                                                type: type,
                                                                id: "rs-".concat(type, "-21"),
                                                                className: "form-check-st-2 tc-7",
                                                                onChange: function() {
                                                                    return setFieldValue("dim_mst_new_status_id", 1);
                                                                },
                                                                isInvalid: !values.dim_mst_new_status_id,
                                                                value: 1,
                                                                checked: values.dim_mst_new_status_id === 1
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                inline: true,
                                                                label: "ยกเลิกเอกสาร",
                                                                name: "dim_mst_new_status_id",
                                                                type: type,
                                                                id: "rs-".concat(type, "-22"),
                                                                className: "form-check-st-2 tc-7",
                                                                onChange: function() {
                                                                    return setFieldValue("dim_mst_new_status_id", 7);
                                                                },
                                                                isInvalid: !values.dim_mst_new_status_id,
                                                                value: 7,
                                                                checked: values.dim_mst_new_status_id === 7
                                                            })
                                                        ]
                                                    }, "inline-".concat(type));
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex align-items-center pb-4 pt-5 ",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    className: "btn-st-6 ms-auto me-3 btn",
                                                    onClick: function() {
                                                        return setModalNotApprove(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: false
                                                            });
                                                        });
                                                    },
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-st-3 ",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalApproveRequestSuccess,
                setModal: setModalApproveRequestSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "ส่งคำขออนุมัติสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalApproveSuccess,
                setModal: setModalApproveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-3",
                        style: {
                            fontSize: "22px",
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "คุณอนุมัติใบขอซื้อ"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-3",
                        style: {
                            fontSize: "22px",
                            color: "#565DFF"
                        },
                        children: "เลขที่ PR-2410000001"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-2 fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#636578"
                        },
                        children: "สำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalAlert,
                setModal: setModalAlert,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center pt-4",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: [
                            "กรุณาเพิ่มรายการสินค้า ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " อย่างน้อย 1 รายการ"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center pb-4 pt-5 ",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-auto",
                            onClick: function() {
                                return setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยืนยัน"
                        })
                    })
                ]
            })
        ]
    });
}
function ProductData(_param) {
    var values = _param.values, setFieldValue = _param.setFieldValue, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, optionNewItemPrCol = _param.optionNewItemPrCol, productRow = _param.productRow, setProductRow = _param.setProductRow, sumproductPrice = _param.sumproductPrice, setSumproductPrice = _param.setSumproductPrice, sumproductNoVat = _param.sumproductNoVat, setSumproductNoVat = _param.setSumproductNoVat, sumproductZeroVat = _param.sumproductZeroVat, setSumproductZeroVat = _param.setSumproductZeroVat, sumproductSevenVat = _param.sumproductSevenVat, setSumproductSevenVat = _param.setSumproductSevenVat, sumproductBeforeVat = _param.sumproductBeforeVat, setSumproductBeforeVat = _param.setSumproductBeforeVat, columnsort = _param.columnsort, setColumnsort = _param.setColumnsort, setFormdata = _param.setFormdata, setPdata = _param.setPdata, formdisabled = _param.formdisabled, props = _object_without_properties(_param, [
        "values",
        "setFieldValue",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "optionNewItemPrCol",
        "productRow",
        "setProductRow",
        "sumproductPrice",
        "setSumproductPrice",
        "sumproductNoVat",
        "setSumproductNoVat",
        "sumproductZeroVat",
        "setSumproductZeroVat",
        "sumproductSevenVat",
        "setSumproductSevenVat",
        "sumproductBeforeVat",
        "setSumproductBeforeVat",
        "columnsort",
        "setColumnsort",
        "setFormdata",
        "setPdata",
        "formdisabled"
    ]);
    var columnoption = [
        {
            value: "productCode",
            label: "รหัสสินค้า"
        },
        {
            value: "qty",
            label: "จำนวน"
        },
        {
            value: "unit",
            label: "หน่วย"
        },
        {
            value: "price_per_unit",
            label: "ราคา/หน่วย"
        },
        {
            value: "discount_type",
            label: "ประเภทส่วนลด"
        },
        {
            value: "discount",
            label: "ส่วนลด/หน่วย"
        },
        {
            value: "price_before_tax",
            label: "มูลค่าก่อนภาษี"
        }
    ];
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    {
                        rowID: nanoid(),
                        productID: "",
                        productCode: "",
                        productName: "",
                        productBarcode: "",
                        supplierCode: "",
                        warehouseID: "",
                        warehouseName: "",
                        productUnit: "",
                        productQty: "",
                        productOrdered: "",
                        ums: "",
                        productStock: "",
                        productPrice: "",
                        discountType: "",
                        discount: "",
                        discountPercent: 0,
                        tax: "",
                        price_before_tax: "",
                        vat: "",
                        note: "",
                        price_after_tax: "",
                        is_checked: false,
                        edit: false
                    }
                ]);
            });
        }
    };
    var checkLength = productRow.filter(function(row) {
        return row.is_checked === true;
    });
    useEffect(function() {
        if (productRow.length <= 0) {
            addProductRow(4);
        }
    }, []);
    useEffect(function() {
        if (values.is_one_receiving_point && productRow.length > 0) {
            setProductRow(function(prev) {
                return prev.map(function(pd) {
                    if (pd.productID) {
                        var warehouseID = values.dim_warehouse_id;
                        var warehouse = optionsWarehouse.find(function(item) {
                            return values.dim_warehouse_id === item.value;
                        });
                        var warehouseName = warehouse ? warehouse.label : "";
                        return _object_spread_props(_object_spread({}, pd), {
                            warehouseID: warehouseID,
                            warehouseName: warehouseName
                        });
                    }
                    return _object_spread({}, pd);
                });
            });
        }
    }, [
        values.dim_warehouse_id
    ]);
    var _useState = _sliced_to_array(useState(0), 2), rowCount = _useState[0], setRowCount = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductQty = _useState1[0], setSumproductQty = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumUms = _useState2[0], setSumUms = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumProductVat = _useState3[0], setSumProductVat = _useState3[1];
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceBeforeVat = 0;
        var priceNoVat = 0;
        var priceZeroVat = 0;
        var priceSevenVat = 0;
        var priceVat = 0;
        var ums = 0;
        productRow.forEach(function(pd) {
            var productQty = parseFloat(pd.productQty);
            var productPrice = parseFloat(pd.productPrice);
            var productRatioUnit = parseInt(pd.productRatioUnit);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            // Calculate price and priceBeforeVat if both quantity and price are valid
            if (hasValidQty) {
                qty += productQty;
                ums += productRatioUnit * productQty;
            }
            if (hasValidQty && hasValidPrice) {
                price += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false);
                priceBeforeVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                // Calculate prices based on VAT type
                switch(parseInt(pd.dim_mst_vat_id)){
                    case 1:
                        priceNoVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 2:
                        priceZeroVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 3:
                        priceSevenVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    default:
                        break;
                }
                priceVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false) - calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
            }
        });
        setSumproductPrice(price);
        setSumproductBeforeVat(priceBeforeVat);
        setSumproductNoVat(priceNoVat);
        setSumproductZeroVat(priceZeroVat);
        setSumproductSevenVat(priceSevenVat);
        setSumProductVat(priceVat);
        setSumproductQty(qty);
        setSumUms(ums);
    };
    useEffect(function() {
        if (values.dim_mst_price_category_id == 3) {
            setProductRowVatByMstCategoryPrice(values.dim_mst_price_category_id, setProductRow);
        }
    }, [
        values.dim_mst_price_category_id
    ]);
    useEffect(function() {
        setRowCount(productRow.length);
        sumQty(productRow);
    // const product = productRow.filter((prev) => prev.productCode !== "");
    // setFieldValue("products", product);
    }, [
        productRow,
        values.dim_mst_price_category_id
    ]);
    var _useState4 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 650,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState4[0], setModal = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "pr-product-sort"
    }), 2), modalSort = _useState5[0], setModalSort = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalDisplayColumn = _useState6[0], setModalDisplayColumn = _useState6[1];
    var _useState7 = _sliced_to_array(useState(null), 2), documentType = _useState7[0], setDocumentType = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 670,
        pin: false,
        mode: "normal",
        modalname: "pr-load-document"
    }), 2), modalLoadDocument = _useState8[0], setModalLoadDocument = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 700,
        pin: false,
        mode: "normal",
        modalname: "pr-select-document"
    }), 2), modalSelectDocument = _useState9[0], setModalSelectDocument = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false,
        productsOrdered: false,
        ums: false,
        productsStock: "",
        vat: false,
        valueIncludingTax: false
    }), 2), columdisplay = _useState10[0], setColumDisplay = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), historyProduct = _useState11[0], setHistoryProduct = _useState11[1];
    var _useState12 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1200,
        height: 600,
        pin: false,
        mode: "normal",
        modalname: "product-history"
    }), 2), modalProductHistory = _useState12[0], setModalProductHistory = _useState12[1];
    useEffect(function() {
        var idisplay = localStorage.getItem("columdisplay");
        if (idisplay) {
            setColumDisplay(JSON.parse(idisplay));
        }
    }, []);
    var items = useMemo(function() {
        return productRow === null || productRow === void 0 ? void 0 : productRow.map(function(param) {
            var rowID = param.rowID;
            return rowID;
        });
    }, [
        productRow
    ]);
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var _useState13 = _sliced_to_array(useState(false), 2), customSort = _useState13[0], setCustomSort = _useState13[1];
    var _useState14 = _sliced_to_array(useState(), 2), activeId = _useState14[0], setActiveId = _useState14[1];
    function handleDragStart(event) {
        setActiveId(event.active.id);
        var active = event.active, over = event.over;
    // console.log(event)
    }
    function handleDragEnd(event) {
        var active = event.active, over = event.over;
        if (active.id !== over.id) {
            setProductRow(function(productRow) {
                var oldIndex = items.indexOf(active.id);
                var newIndex = items.indexOf(over.id);
                return arrayMove(productRow, oldIndex, newIndex);
            });
        }
        setActiveId(null);
    }
    function handleDragCancel() {
        setActiveId(null);
    }
    var selectedRow = useMemo(function() {
        if (!activeId) {
            return null;
        }
        var row = productRow.filter(function(prev) {
            return prev.rowID == activeId;
        });
        return row;
    }, [
        activeId
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: "เพิ่มสินค้าหลายรายการ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductSelect, {
                    productRow: productRow,
                    setProductRow: setProductRow,
                    addProductRow: addProductRow,
                    optionsWarehouse: optionsWarehouse,
                    optionsMstVat: optionsMstVat,
                    values: values
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSort,
                setModal: setModalSort,
                htitle: "จัดเรียง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableSort, {
                    columnsort: columnsort,
                    setColumnsort: setColumnsort,
                    columnoption: optionNewItemPrCol,
                    setCustomSort: setCustomSort,
                    setModal: setModalSort,
                    productRow: productRow,
                    setProductRow: setProductRow,
                    setFieldValue: setFieldValue,
                    fieldName: "dim_new_item_pr_sorts"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayColumn,
                setModal: setModalDisplayColumn,
                htitle: "ตัวเลือกการแสดงผล PR",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableDisplay, {
                    columdisplay: columdisplay,
                    columdisplayName: "columdisplay",
                    setModalDisplayColumn: setModalDisplayColumn,
                    setColumDisplay: setColumDisplay
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalLoadDocument,
                setModal: setModalLoadDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(LoadDocument, {
                    columdisplay: columdisplay,
                    setModal: setModalLoadDocument,
                    setDocumentType: setDocumentType,
                    setModalSelectDocument: setModalSelectDocument,
                    setProductRow: setProductRow,
                    setFormdata: setFormdata,
                    setPdata: setPdata
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSelectDocument,
                setModal: setModalSelectDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: documentType
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalProductHistory,
                setModal: setModalProductHistory,
                htitle: "ดูประวัติสินค้า",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductHistory, {
                    historyProduct: historyProduct,
                    setModalProductHistory: setModalProductHistory
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: checkLength.length > 0 ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            type: "button",
                            onClick: function() {
                                setHistoryProduct(checkLength);
                                setModalProductHistory(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            disabled: checkLength.length != 1,
                            children: "ดูประวัติสินค้า"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                var checkLenght = productRow.filter(function(item) {
                                    return item.is_checked === true;
                                }).length;
                                setProductRow(function(productRow) {
                                    return productRow.filter(function(item) {
                                        return item.is_checked !== true;
                                    });
                                });
                                addProductRow(checkLenght);
                            },
                            children: "ลบที่เลือก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        return _object_spread_props(_object_spread({}, el), {
                                            is_checked: false
                                        });
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        })
                    ]
                }) : customSort ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "alert-w",
                            children: "กรุณาเลือกที่แถวเพื่อจัดลำดับ"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            className: "btn btn-st-x1 me-2",
                            children: "บันทึกการจัดเรียง"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            children: "ยกเลิกการจัดเรียง"
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 flex",
                    children: [
                        /*#__PURE__*/ _jsx("fieldset", {
                            disabled: formdisabled,
                            children: /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-st-x1 me-2",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: true
                                        });
                                    });
                                },
                                children: "เพิ่มหลายรายการ"
                            })
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                return setModalSort(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "จัดเรียง"
                        }),
                        /*#__PURE__*/ _jsxs("fieldset", {
                            disabled: formdisabled,
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                        return setModalLoadDocument(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: true
                                            });
                                        });
                                    },
                                    children: "โหลดเอกสาร"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                        setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                            setFormdata: setFormdata,
                                            setProductRow: setProductRow,
                                            setPdata: setPdata,
                                            setModal: setModalSelectDocument
                                        }));
                                        setModalSelectDocument(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: true
                                            });
                                        });
                                    },
                                    children: "โหลดใบขอซื้อ"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                    // setDocumentType(<LoadPR setModal={setModalSelectDocument} />);
                                    // setModalSelectDocument((prev) => ({ ...prev, open: true }));
                                    },
                                    children: "โหลดใบสั่งขาย"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                    // setDocumentType(<LoadPR setModal={setModalSelectDocument} />);
                                    // setModalSelectDocument((prev) => ({ ...prev, open: true }));
                                    },
                                    children: "โหลดใบสั่งซื้อ"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setModalDisplayColumn(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "ตัวเลือกแสดงผล"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("fieldset", {
                disabled: formdisabled,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "pagezoom",
                        style: {
                            overflowX: "auto",
                            maxWidth: "100%",
                            overflowY: "hidden",
                            paddingBottom: "20px"
                        },
                        children: /*#__PURE__*/ _jsxs(DndContext, {
                            sensors: sensors,
                            collisionDetection: closestCenter,
                            onDragEnd: handleDragEnd,
                            onDragCancel: handleDragCancel,
                            onDragStart: handleDragStart,
                            modifiers: [
                                restrictToVerticalAxis
                            ],
                            children: [
                                /*#__PURE__*/ _jsx(SortableContext, {
                                    items: productRow,
                                    strategy: verticalListSortingStrategy,
                                    children: /*#__PURE__*/ _jsxs("table", {
                                        className: "column_resize_table table1 table-striped ",
                                        style: {
                                            width: "auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("thead", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "form-check form-check-st-t1",
                                                                children: customSort ? "" : /*#__PURE__*/ _jsx("input", {
                                                                    className: "form-check-input",
                                                                    type: "checkbox",
                                                                    name: "",
                                                                    onChange: function(e) {
                                                                        if (e.target.checked === true) {
                                                                            setProductRow(function(prev) {
                                                                                return prev.map(function(el) {
                                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                                        is_checked: true
                                                                                    });
                                                                                });
                                                                            });
                                                                        } else {
                                                                            setProductRow(function(prev) {
                                                                                return prev.map(function(el) {
                                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                                        is_checked: false
                                                                                    });
                                                                                });
                                                                            });
                                                                        }
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 35
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "รหัสสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            defaultWidth: 200,
                                                            minWidth: 5
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "รายการ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 200
                                                        }),
                                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "บาร์โค้ด"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 5,
                                                                    defaultWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "รหัสสินค้าผู้ขาย"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 5,
                                                                    defaultWidth: 130
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "คลังจัดส่ง"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "หน่วย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "จำนวน"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 100
                                                        }),
                                                        columdisplay.productsOrdered ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#FF731D",
                                                                        color: "#FFF"
                                                                    },
                                                                    children: "จำนวนสินค้าที่สั่งแล้ว"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-FF731D",
                                                                    minWidth: 5,
                                                                    defaultWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#3FA5FF",
                                                                        color: "#FFF"
                                                                    },
                                                                    children: "จำนวน UMS"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-3FA5FF",
                                                                    "bg-FF731D": true,
                                                                    minWidth: 5,
                                                                    defaultWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.productsStock ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#666CFF",
                                                                        color: "#FFF"
                                                                    },
                                                                    children: "สินค้าคงเหลือ"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-666CFF ",
                                                                    minWidth: 5,
                                                                    defaultWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ราคา/หน่วย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 110
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ประเภทส่วนลด"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 140
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ส่วนลด/หน่วย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 120
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ภาษี"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 80
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "มูลค่าก่อนภาษี"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 100
                                                        }),
                                                        columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "ภาษีมูลค่าเพิ่ม"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 5,
                                                                    defaultWidth: 120
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "มูลค่ารวมภาษี"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 5,
                                                                    defaultWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "หมายเหตุ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 5,
                                                            defaultWidth: 100
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tbody", {
                                                children: productRow.map(function(item, index) {
                                                    return /*#__PURE__*/ _jsx(Productrow, {
                                                        item: item,
                                                        index: index,
                                                        setProductRow: setProductRow,
                                                        columdisplay: columdisplay,
                                                        customSort: customSort,
                                                        rowCount: rowCount,
                                                        addProductRow: addProductRow,
                                                        optionsWarehouse: optionsWarehouse,
                                                        optionsMstDiscountType: optionsMstDiscountType,
                                                        optionsMstVat: optionsMstVat,
                                                        values: values
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tfoot", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {}),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {}),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "prCode",
                                                                className: "form-control text-center",
                                                                placeholder: "",
                                                                value: sumproductQty,
                                                                disabled: true,
                                                                style: {
                                                                    position: "absolute",
                                                                    right: "-0.5vw",
                                                                    top: "10px"
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body "
                                                        }),
                                                        columdisplay.productsOrdered ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {}),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumUms,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 0,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-center",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.productsStock ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {}),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                value: sumproductBeforeVat,
                                                                thousandSeparator: ",",
                                                                decimalScale: 2,
                                                                fixedDecimalScale: true,
                                                                customInput: function(e) {
                                                                    return /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "",
                                                                        className: "form-control text-end",
                                                                        placeholder: "",
                                                                        value: e.value,
                                                                        disabled: true,
                                                                        style: {
                                                                            position: "absolute",
                                                                            right: "-0.5vw",
                                                                            top: "10px"
                                                                        }
                                                                    });
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumProductVat,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-end",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumproductPrice,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-end",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : ""
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(DragOverlay, {
                                    children: /*#__PURE__*/ _jsxs("table", {
                                        className: "column_resize_table table1 table-striped  table-thead-0",
                                        style: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("thead", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    style: {
                                                        height: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 35
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 130
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        columdisplay.productsOrdered ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#FF731D",
                                                                        color: "#FFF"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-FF731D",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#3FA5FF",
                                                                        color: "#FFF"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-3FA5FF",
                                                                    "bg-FF731D": true,
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.productsStock ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#666CFF",
                                                                        color: "#FFF"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-666CFF ",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 110
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 140
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 120
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 80
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 120
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tbody", {
                                                children: /*#__PURE__*/ _jsx(Productrow, {
                                                    item: selectedRow ? selectedRow[0] : "",
                                                    index: 0,
                                                    setProductRow: setProductRow,
                                                    columdisplay: columdisplay,
                                                    customSort: customSort,
                                                    values: values
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4 pagezoom",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 me-3",
                            onClick: function() {
                                return addProductRow(5);
                            },
                            children: "เพิ่มแถว"
                        })
                    })
                ]
            })
        ]
    });
}
function Steps(_param) {
    var prstatus = _param.prstatus, props = _object_without_properties(_param, [
        "prstatus"
    ]);
    var steps = [
        "สร้างใบขอซื้อ",
        "ขออนุมัติใบขอซื้อ",
        "กำลังดำเนินการ",
        "เสร็จสิ้น"
    ];
    var mappingStatus = function(prstatus) {
        var index = 0;
        switch(prstatus){
            case 1:
                index = 1;
                break;
            case 2:
                index = 2;
                break;
            case 3:
                index = 3;
                break;
            case 6:
                index = 4;
                break;
            default:
                index = 0;
                break;
        }
        return index;
    };
    var _useState = _sliced_to_array(useState(mappingStatus(prstatus)), 2), activeStep = _useState[0], setActiveStep = _useState[1];
    useEffect(function() {
        setActiveStep(mappingStatus(prstatus));
    }, [
        prstatus
    ]);
    return /*#__PURE__*/ _jsx(Stepper, {
        activeStep: activeStep,
        alternativeLabel: true,
        children: steps.map(function(label, index) {
            var stepProps = {};
            var labelProps = {};
            return /*#__PURE__*/ _jsx(Step, _object_spread_props(_object_spread({}, stepProps), {
                children: /*#__PURE__*/ _jsx(StepLabel, _object_spread_props(_object_spread({}, labelProps), {
                    style: {
                        fontSize: "16px"
                    },
                    children: label
                }))
            }), label);
        })
    });
}
function OrderDetail(param) {
    var dimNewPurchaseOrder = param.dimNewPurchaseOrder;
    // const [documents, setDocuments] = useState([
    //   {
    //     documentID: 1,
    //     documentName: "ใบสั่งซื้อ",
    //     documentCode: "PO-2410000001",
    //     documentDate: "02/04/2024",
    //     quantity: 100,
    //     netValue: "67,000.00",
    //     documentIssuer: "นาย มงคล จิตดี",
    //   },
    //   {
    //     documentID: 2,
    //     documentName: "ใบสั่งซื้อ",
    //     documentCode: "PO-2410000001",
    //     documentDate: "02/04/2024",
    //     quantity: 100,
    //     netValue: "67,000.00",
    //     documentIssuer: "นาย มงคล จิตดี",
    //   },
    // ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "pagezoom",
            children: /*#__PURE__*/ _jsxs("table", {
                className: "column_resize_table table1 table-striped ",
                style: {
                    width: "auto"
                },
                children: [
                    /*#__PURE__*/ _jsx("thead", {
                        children: /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("th", {
                                    children: "เอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 100
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "เลขที่เอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 140
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "วันที่ออกเอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 140
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "จำนวน"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 100
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "มูลค่าสุทธิ"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 100
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "ผู้ออกเอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: "auto"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("tbody", {
                        children: dimNewPurchaseOrder.map(function(item, index) {
                            return /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: "ใบสั่งซื้อ"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx("a", {
                                            className: "tc-9",
                                            href: "/purchase/order/edit/".concat(item.id),
                                            target: "_blank",
                                            children: item.doc_number
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: moment(item.doc_issue_date).format("DD/MM/YYYY")
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: NumberFormat(item.total_quantity, 0)
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: NumberFormat(item.grand_total_price, 2)
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: getEmpFullNameTHByEmpData(item.createdNewPoEmp)
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            });
                        })
                    })
                ]
            })
        })
    });
}
function getCurrentDate() {
    var separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", dateb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var newDate = dateb;
    var date = newDate.getDate();
    var month = newDate.getMonth() + 1;
    var year = newDate.getFullYear();
    return "".concat(date).concat(separator).concat(month < 10 ? "0".concat(month) : "".concat(month)).concat(separator).concat(year);
}
